const cookieName = 'NEWMESSAGE';

export default {
    cookieName,
};
